// src/data/comedians/richard-pryor.js

const base = {
  id: 'richard-pryor',
  slug: 'richard-pryor',
  name: 'Richard Pryor',
  birthYear: 1940,
  image: require('@/assets/images/img_Richard_Pryor.png'),
  famousWorks: [
    "That Nigger's Crazy (1974)",
    'Richard Pryor: Live in Concert (1979)',
    'Silver Streak (1976)',
    'Stir Crazy (1980)',
    "Brewster's Millions (1985)",
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Groundbreaking stand-up revolutionary',
    bio: `Richard Pryor was an American stand-up comedian, actor, and writer widely regarded as one of the greatest and most influential comedians of all time. His raw, honest, and often controversial comedy broke barriers and paved the way for future generations.\n\nBorn in Peoria, Illinois, Pryor grew up in difficult circumstances that would later inform his comedy. He began performing stand-up in the 1960s, initially imitating Bill Cosby before finding his own authentic voice.\n\nPryor's comedy was groundbreaking in its honesty about race, social issues, and personal struggles. His concert film "Richard Pryor: Live in Concert" (1979) is considered a masterpiece of the form. His influence on comedy is immeasurable, inspiring Eddie Murphy, Chris Rock, and Dave Chappelle, among countless others.`,
    style: 'Raw, honest, confessional, racially and socially conscious',
    achievements: [
      'Five Grammy Awards for comedy albums',
      'Emmy Award',
      'Mark Twain Prize for American Humor (1998)',
      'Kennedy Center Honors',
      "Ranked #1 on Comedy Central's list of all-time greatest stand-ups",
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Révolutionnaire du stand-up qui a tout changé',
    bio: `Richard Pryor était un comédien de stand-up, acteur et écrivain américain largement considéré comme l'un des plus grands et influents comédiens de tous les temps. Sa comédie brute, honnête et souvent controversée a brisé des barrières et ouvert la voie aux générations suivantes.\n\nNé à Peoria dans l'Illinois, Pryor a grandi dans des conditions difficiles qui ont nourri son humour. Il débute dans le stand-up dans les années 1960, imitant d'abord Bill Cosby avant de trouver sa propre voix authentique.\n\nSa comédie était révolutionnaire par son honnêteté sur la race, les questions sociales et ses luttes personnelles. Son film de concert "Richard Pryor: Live in Concert" (1979) est considéré comme un chef-d'œuvre du genre.`,
    style: 'Cru, honnête, confessionnel, conscient des enjeux raciaux et sociaux',
    achievements: [
      'Cinq Grammy Awards pour albums de comédie',
      'Emmy Award',
      'Mark Twain Prize for American Humor (1998)',
      'Kennedy Center Honors',
      "Classé n°1 par Comedy Central parmi les plus grands humoristes de tous les temps",
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Revolucionario del stand-up que lo cambió todo',
    bio: `Richard Pryor fue un comediante de stand-up, actor y escritor estadounidense ampliamente considerado como uno de los más grandes e influyentes comediantes de todos los tiempos. Su comedia cruda, honesta y a menudo controvertida rompió barreras y abrió el camino a futuras generaciones.\n\nNacido en Peoria, Illinois, Pryor creció en circunstancias difíciles que alimentaron su humor. Comenzó en el stand-up en los años 60, imitando inicialmente a Bill Cosby antes de encontrar su propia voz auténtica.\n\nSu comedia fue revolucionaria en su honestidad sobre la raza, los problemas sociales y sus luchas personales. Su película de concierto "Richard Pryor: Live in Concert" (1979) es considerada una obra maestra del género.`,
    style: 'Crudo, honesto, confesional, consciente de lo racial y lo social',
    achievements: [
      'Cinco Grammy Awards por álbumes de comedia',
      'Emmy Award',
      'Mark Twain Prize for American Humor (1998)',
      'Kennedy Center Honors',
      "Clasificado n.º 1 por Comedy Central entre los mejores stand-ups de todos los tiempos",
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'ثوري الستاند أب الذي غيّر قواعد اللعبة',
    bio: `ريتشارد برايور كوميدي ستاند أب وممثل وكاتب أمريكي يُعدّ على نطاق واسع من أعظم الكوميديين وأكثرهم تأثيرًا في التاريخ. حطّمت كوميديا الخام والصادقة والجريئة الحواجز ومهّدت الطريق للأجيال القادمة.\n\nوُلد في بيوريا بولاية إلينوي، ونشأ في ظروف صعبة غذّت لاحقًا كوميديا. بدأ في الستاند أب خلال الستينيات مقلّدًا بيل كوسبي في البداية قبل أن يجد صوته الأصيل.\n\nتميّزت كوميديا بصدقها الصارخ حول العرق والقضايا الاجتماعية والصراعات الشخصية. ويُعدّ فيلمه الكوميدي المباشر "Richard Pryor: Live in Concert" (1979) تحفةً فنية في هذا الفن. وقد ألهم إيدي مورفي وكريس روك وعددًا لا يحصى من الكوميديين.`,
    style: 'خام وصادق واعترافي، واعٍ بالقضايا العرقية والاجتماعية',
    achievements: [
      'خمس جوائز Grammy لألبومات الكوميديا',
      'جائزة Emmy',
      'جائزة مارك توين للفكاهة الأمريكية (1998)',
      'Kennedy Center Honors',
      'صنّفته Comedy Central الأول في قائمة أعظم كوميديي الستاند أب على الإطلاق',
    ],
  },
];
